import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { format } from 'date-fns';
import { bankInfo, currency, invoiceItem } from '../../utils/constant';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import useFormValidation from '../../hooks/useFormValidation';
import { accomodationFormValidationSchema } from '../../utils/formValidation';
import { normalizeDate, convertToSubcurrency, convertToUTCDateInputFormat } from '../../utils/utility';
import { getPassportById, getStudentById } from '../../services/studentApi';
import { errorToast } from '../../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { getAccommodationForm, topUpAndRefund, updateAccommodationById } from '../../services/accomodationApi';
import { IoInformationCircle } from "react-icons/io5";
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { FaBed, FaEdit, FaFilePdf } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
import CustomModal from '../../components/CustomModal';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import Checkout from '../../components/Checkout';
import { PDFDocument, StandardFonts } from 'pdf-lib';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const base_url = process.env.REACT_APP_BASE_URL

const ViewAccomodation = () => {
    const navigate = useNavigate();
    const [isChangeRoomModalOpen, setIsChangeRoomModalOpen] = useState(false);
    const toggleChangeRoomModal = () => {
        setIsChangeRoomModalOpen(!isChangeRoomModalOpen);
    };
    const [isAddOnBedModalOpen, setIsAddOnBedModalOpen] = useState(false);
    const toggleAddOnBedModal = () => {
        setIsAddOnBedModalOpen(!isAddOnBedModalOpen);
    };
    const [isChangeRoommateModalOpen, setIsChangeRoommateModalOpen] = useState(false);
    const toggleChangeRoommateModal = () => {
        setIsChangeRoommateModalOpen(!isChangeRoommateModalOpen);
    };
    const closeChangeRoommateModal = () => {
        setIsChangeRoommateModalOpen(false);
        setFormData(originalData);
    };
    const [isChangeStayDateModalOpen, setIsChangeStayDateModalOpen] = useState(false);
    const toggleChangeStayDateModal = () => {
        setIsChangeStayDateModalOpen(!isChangeStayDateModalOpen);
    };
    const closeChangeStayDateModal = () => {
        setIsChangeStayDateModalOpen(false);
        setIsEditing(true);
    };
    const { t } = useTranslation();
    const currencyCopy = currency(t);
    const bankInfoCopy = bankInfo(t);
    const invoiceItemCopy = invoiceItem(t);
    const [formData, setFormData] = useState("");
    const [originalData, setOriginalData] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [passportRegion, setPassportRegion] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(accomodationFormValidationSchema(t));
    const [totalStayDaysBefore, setTotalStayDaysBefore] = useState(0);
    const [totalStayDaysNow, setTotalStayDaysNow] = useState(0);
    const [extendStayDay, setExtendStayDay] = useState(0);
    const [earlyStayDay, setEarlyStayDay] = useState(0);
    const [differentStayDays, setDifferentStayDays] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [currencySelected, setCurrencySelected] = useState({
        key: "",
        currency: "",
        rate: 1,
    });
    const [checkoutItem, setCheckoutItem] = useState({
        isRefund: 0,
        amountDifference: 0,
        tourismTax: 0,
    });
    const [transactionFee, setTransactionFee] = useState(0);
    const [totalAmount, setTotalAmount] = useState({ totalAmount: 0, totalAmountInCurrencySelected: 0 });
    const [netTotalAmount, setNetTotalAmount] = useState(0);

    const fetchPassport = async () => {
        try {
            const passportData = await getPassportById();
            if (passportData) {
                setPassportRegion(passportData.passport_region);
            }
        } catch (error) {
            console.log(error, t("Passport.warning"));
        }
    };

    const fetchAccommodation = async () => {
        setIsLoading(true);
        try {
            const data = await getAccommodationForm();
            if (data) {
                setFormData({
                    is_compliance_health_measure: data.is_compliance_health_measure,
                    check_in_date: "",
                    check_out_date: "",
                    is_addon_bed: data.is_addon_bed,
                    is_early_check_in: data.is_early_check_in,
                    is_extend_stay: data.is_extend_stay,
                    is_roommate: data.is_roommate,
                    offline_payment_currency: "",
                    offline_payment_prove: "",
                    payment_mode: "",
                    room_type: data.room_type,
                    room_type_assigned: data.room_type_assigned,
                    roommate_id: data.roommate_id,
                    roommate_name: data.roommate_name,
                    roommate_relationship: data.roommate_relationship,
                });
                setOriginalData({
                    is_compliance_health_measure: data.is_compliance_health_measure,
                    check_in_date: data.check_in_date,
                    check_out_date: data.check_out_date,
                    is_addon_bed: data.is_addon_bed,
                    is_early_check_in: data.is_early_check_in,
                    is_extend_stay: data.is_extend_stay,
                    is_roommate: data.is_roommate,
                    offline_payment_currency: data.offline_payment_currency,
                    offline_payment_prove: data.offline_payment_prove,
                    payment_mode: data.payment_mode,
                    room_type: data.room_type,
                    room_type_assigned: data.room_type_assigned,
                    roommate_id: data.roommate_id,
                    roommate_name: data.roommate_name,
                    roommate_relationship: data.roommate_relationship,
                });
                const oriStartDate = normalizeDate(data.check_in_date);
                const oriEndDate = normalizeDate(data.check_out_date);

                setTotalStayDaysBefore(
                    ((oriEndDate - oriStartDate) / (1000 * 60 * 60 * 24)) + 1
                );
            }
        } catch (error) {
            errorToast(error, t("general.Reload"), t);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAccommodation();
        fetchPassport();
    }, []);

    useEffect(() => {
        const room_type_price = formData?.room_type === "singleroom" ? "earlyStaySingleRoom" : "earlyStay";
        setCheckoutItem((prevState) => ({
            ...prevState,
            amountDifference: differentStayDays * invoiceItemCopy.filter((item) => item.key === room_type_price).map((item) => item.amount)[0],
            isRefund: differentStayDays < 0 ? "1" : "0"
        }));
        if (passportRegion !== "Malaysia" && passportRegion !== "") {
            setCheckoutItem((prevState) => ({
                ...prevState,
                tourismTax: differentStayDays * invoiceItemCopy.filter((item) => item.key === "tourismTax").map((item) => item.amount)[0],
            }));
        }
    }, [differentStayDays])

    useEffect(() => {
        let totalNet = (Number(checkoutItem.amountDifference)).toFixed(2);
        let totalSum = (Number(totalNet) + Number(checkoutItem.tourismTax) + Number(transactionFee)).toFixed(2);
        let totalInCurrencySelected = (Number(totalSum) * Number(currencySelected.rate)).toFixed(2);
        setNetTotalAmount(totalNet);
        setTotalAmount({
            totalAmount: totalSum,
            totalAmountInCurrencySelected: totalInCurrencySelected
        });
    }, [checkoutItem, transactionFee, currencySelected]);

    useEffect(() => {
        setTransactionFee(paymentMethod === "creditcard" ? ((0.04 * (Number(netTotalAmount) + Number(checkoutItem.tourismTax)) + 1) / 0.96).toFixed(2) : 0);
    }, [totalAmount, paymentMethod]);

    const handleCurrencyChange = (e) => {
        const { id, value } = e.target;
        const currencyInfo = currencyCopy.filter((item) => item.key === value);
        setCurrencySelected({
            key: currencyInfo.length >= 1 ? currencyInfo[0].key : "",
            currency: currencyInfo.length >= 1 ? currencyInfo[0].currency : "",
            rate: currencyInfo.length >= 1 ? currencyInfo[0].rate : 1
        });
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value)
    }

    const handleCancel = () => {
        window.location.reload();
    };

    const [fileError, setFileError] = useState("");
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    const handleFileChange = (event) => {
        const { id } = event.target;
        const selectedFile = event.target.files[0];
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "image/jpg",
            "image/heic"
        ];
        if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
            setFileError(t("FormValid.FileExtensionAllow"));
            event.target.value = ""; // Clear the file input
            return;
        } else if (selectedFile && selectedFile.size > maxSize) {
            setFileError(t("FormValid.smallerFile"));
            event.target.value = ""; // Clear the file input
            return;
        } else {
            setFileError("");
            setFormData((prevState) => ({
                ...prevState,
                [id]: selectedFile,
            }));
            validateField(id, selectedFile);
        }
    };

    const setNullFormToEmpty = (nullFormData) => {
        for (const [key, value] of Object.entries(nullFormData)) {
            if (value === null || value === undefined) {
                nullFormData[key] = ''; // Replace with an empty string
            }
        }
        return nullFormData;
    }
    const generateValidationFields = () => {
        let validationFields = ["is_compliance_health_measure", "room_type", "is_addon_bed", "is_roommate", "check_in_date", "check_out_date"];
        formData.is_roommate === "1" && validationFields.push("roommate_id", "roommate_name", "roommate_relationship");
        if (checkoutItem.isRefund === "0") {
            if (checkoutItem.amountDifference > 0) {
                validationFields.push("payment_mode");
            }
            formData.payment_mode === "offline" &&
                validationFields.push("offline_payment_currency", "offline_payment_prove")
        }
        return validationFields;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        let transformedFormData = setNullFormToEmpty(formData);
        let validationFields = generateValidationFields();
        try {
            if (validateAllFields(transformedFormData, validationFields) && fileError === "") {
                // Step 4: Submit form data
                const combinedFormData = {
                    ...formData,
                    ...checkoutItem,
                    ...totalAmount,
                    transactionFee: transactionFee,
                    netTotalAmount: netTotalAmount,
                    payment_type: checkoutItem.isRefund === "1" ? "Refund" : "Top-Up"
                };
                const response = await topUpAndRefund(combinedFormData);
                if (response) {
                    toast.success(t("accomodation.RequestDone"));
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, value, name } = e.target;

        if (name === "is_addon_bed" || name === "payment_mode") {
            setFormData((prevState) => ({
                ...prevState,
                [name]: id,
            }));
            if (name === "payment_mode") {
                setPaymentMethod(id);
                setCurrencySelected({
                    key: "",
                    currency: "",
                    rate: 1
                });
            }
            validateField(name, id);
        } else if (name === "is_roommate") {
            if (id === "1") {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                    roommate_id: "",
                    roommate_name: "",
                    roommate_relationship: ""
                }));
            }
        } else if (id === "check_in_date" || id === "check_out_date") {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
            // if (!errors.check_in_date || !errors.check_out_date) {
            let desiredStartDate = normalizeDate('2025-03-26');
            let desiredEndDate = normalizeDate('2025-04-01');
            if (id === "check_in_date") {
                desiredStartDate = normalizeDate(value);
                const startDate = normalizeDate('2025-03-26');
                let earlyStayDayVar = (startDate - desiredStartDate) / (1000 * 60 * 60 * 24);// Convert milliseconds to days
                setEarlyStayDay(earlyStayDayVar);
                setFormData((prevState) => ({
                    ...prevState,
                    is_early_check_in: earlyStayDayVar !== 0 ? 1 : 0,
                }))
            } else {
                desiredEndDate = normalizeDate(value);
                const endDate = normalizeDate('2025-04-01');
                let extendStayDayVar = (desiredEndDate - endDate) / (1000 * 60 * 60 * 24);
                setExtendStayDay(extendStayDayVar);
                setFormData((prevState) => ({
                    ...prevState,
                    is_extend_stay: extendStayDayVar !== 0 ? 1 : 0,
                }))
            }
            // }
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
        }
    };

    useEffect(() => {
        if (formData.check_in_date !== "" && formData.check_out_date !== "" && totalStayDaysBefore !== 0) {
            setTotalStayDaysNow(
                (earlyStayDay + extendStayDay + 7)
            );
            setDifferentStayDays(
                ((earlyStayDay + extendStayDay + 7) - totalStayDaysBefore)
            );
        }
    }, [formData])

    const handleUpdate = async (flag, closeModal) => {
        setIsSubmitting(true);
        let updateFormData = {};
        let formKey = [];
        switch (flag) {
            case "roomChange":
                updateFormData = { "room_type": formData.room_type === "twinroom" ? "kingroom" : "twinroom" };
                formKey = Object.keys(updateFormData);
                break;
            case "addOnBed":
                updateFormData = { "is_addon_bed": formData.is_addon_bed === "1" ? "0" : "1" };
                formKey = Object.keys(updateFormData);
                break;
            case "roommateChange":
                updateFormData = {
                    "is_roommate": formData.is_roommate,
                    "roommate_id": formData.roommate_id,
                    "roommate_name": formData.roommate_name,
                    "roommate_relationship": formData.roommate_relationship
                };
                if (formData.is_roommate === "1") {
                    formKey = Object.keys(updateFormData);
                } else {
                    formKey = ["is_roommate"];
                }
                break;
        }
        if (validateAllFields(updateFormData, formKey)) {
            try {
                const response = await updateAccommodationById(updateFormData);
                if (response) {
                    toast.success(t("accomodation.RequestChange"));
                    fetchAccommodation();
                    closeModal();
                }
            } catch (error) {
                errorToast(error, t("general.failSubmit"), t);
            } finally {
                setIsSubmitting(false);
            }
        } else {
            toast.error(t("general.ValidationFail"));
            setIsSubmitting(false);
        }
    }

    const handleDownloadConfirmation = async () => {
        // Show loading state
        toast.info(t("accomodation.GeneratingPDF"));
        
        try {
            // Fetch user data
            const userData = await getStudentById();
            const accommodationData = await getAccommodationForm();
            
            if (!userData || !accommodationData) {
                throw new Error('Failed to fetch user or accommodation data');
            }
            
            // Load the PDF template
            const templateUrl = `${base_url}/pdf_template/hotel_confirmation.pdf`;
            const templateBytes = await fetch(templateUrl).then(res => {
                if (!res.ok) {
                    throw new Error(`Failed to fetch template: ${res.status} ${res.statusText}`);
                }
                return res.arrayBuffer();
            });
            
            // Load the PDF document
            const pdfDoc = await PDFDocument.load(templateBytes);
            
            // Get the first page
            const pages = pdfDoc.getPages();
            if (pages.length === 0) {
                throw new Error('PDF template has no pages');
            }
            const firstPage = pages[0];
            
            // Get the standard font
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
            
            // Set text properties
            const fontSize = 11;
            
            // Format dates
            const formatDate = (dateString) => {
                if (!dateString) return '';
                const date = new Date(dateString);
                // Convert to UTC and format
                return new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    timeZone: 'UTC'
                }).format(date);
            };
            
            // Get page dimensions to help with positioning
            const { width, height } = firstPage.getSize();
            
            // Add user information to the PDF
            // Adjust these values based on the actual template
            
            // Guest Name - Position next to  "Guest Name:"
            firstPage.drawText(userData.ename || '', {
                x: 390,
                y: height - 200, // Positioning from top
                size: fontSize,
                font: boldFont,
                encoding: 'utf-8' // Use UTF-8 encoding
            });
            
            // Check-in date - Position next to "Arrival Date："
            const checkInDate = formatDate(accommodationData.check_in_date);
            firstPage.drawText(checkInDate, {
                x: 450,
                y: height - 358, // Positioning from top
                size: fontSize,
                font,
                encoding: 'utf-8' // Use UTF-8 encoding
            });
            
            // Check-out date - Position next to "Departure Date:""
            const checkOutDate = formatDate(accommodationData.check_out_date);
            firstPage.drawText(checkOutDate, {
                x: 460,
                y: height - 410, // Positioning from top
                size: fontSize,
                font,
                encoding: 'utf-8' // Use UTF-8 encoding
            });
            
            // Room type - Position next to "房间类型："
            const roomType = "Superior Room";
            firstPage.drawText(roomType, {
                x: 465,
                y: height - 463, // Positioning from top
                size: fontSize,
                font,
                encoding: 'utf-8' // Use UTF-8 encoding
            });
            
            // Save the PDF with options
            const pdfBytes = await pdfDoc.save({
                useObjectStreams: false // This can help with compatibility
            });
            
            // Create a blob from the PDF bytes with explicit MIME type
            const blob = new Blob([pdfBytes], { 
                type: 'application/pdf;charset=utf-8' 
            });
            
            // Create a download link and trigger download
            const fileName = `hotel_confirmation.pdf`;
            
            try {
                // Try using the download attribute first
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                
                // Set link properties
                link.href = url;
                link.download = fileName;
                link.type = 'application/pdf';
                link.style.display = 'none';
                
                // Add to document, click, and cleanup
                document.body.appendChild(link);
                
                // Use a promise to handle the click event
                await new Promise((resolve) => {
                    link.onclick = resolve;
                    link.click();
                });
                
                // Cleanup after a short delay
                setTimeout(() => {
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }, 1000);
                
                // Show success message
                toast.success(t("accomodation.PDFDownloaded"));
            } catch (downloadError) {
                // Fallback: Try opening in a new window
                console.warn('Download failed, trying fallback method:', downloadError);
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                
                // Cleanup URL after a delay
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 1000);
                
                toast.info(t("accomodation.PDFOpenedInNewTab"));
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error(`${t("accomodation.FailedToDownloadPDF")}: ${error.message}`);
        }
    };

    return (
        <>
            <CustomModal
                hideModal={toggleChangeRoomModal}
                open={isChangeRoomModalOpen}
                performAction={() => handleUpdate("roomChange", toggleChangeRoomModal)}
                title={t("accomodation.UpdateInformation")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("accomodation.ChangeROOM")} {formData?.room_type === "twinroom" ? t("Constant.KingRoom") : t("Constant.TwinRoom")}?
                    </p>
                }
            />
            {/* <CustomModal
                hideModal={toggleChangeRoomModal}
                open={isChangeRoomModalOpen}
                performAction={() => navigate(`${base_url}/change_to_single_room`)}
                title={t("accomodation.UpdateInformation")}
                children={
                    <p>
                        {t("accomodation.ConfirmationChangeRoom")}
                    </p>
                }
            /> */}
            <CustomModal
                hideModal={toggleAddOnBedModal}
                open={isAddOnBedModalOpen}
                performAction={() => handleUpdate("addOnBed", toggleAddOnBedModal)}
                title={t("accomodation.UpdateInformation")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("accomodation.Sure")} {formData?.is_addon_bed === "1" && <span className='error'>{t("general.BTNcancel")}</span>} {t("accomodation.AddON")}?
                    </p>
                }
            />
            <CustomModal
                hideModal={closeChangeRoommateModal}
                open={isChangeRoommateModalOpen}
                performAction={() => handleUpdate("roommateChange", toggleChangeRoommateModal)}
                title={t("accomodation.RoommateModified")}
                confirmLoading={isSubmitting}
                children={
                    <>
                        <div className="form-item">
                            <label>{t("accomodation.Roommate_Question")}
                                <span style={{ "color": "#ff0000" }}>*</span></label>
                            <div className='radio'>
                                <input
                                    className="form-check-input p-2"
                                    type="radio"
                                    name="is_roommate"
                                    id="1"
                                    checked={formData?.is_roommate === "1"}
                                    onChange={handleInputChange}
                                    required
                                />
                                <p className='radioLabel mb-0'>{t("general.yes")}</p>
                            </div>
                            <div className='radio'>
                                <input
                                    className="form-check-input p-2"
                                    type="radio"
                                    name="is_roommate"
                                    id="0"
                                    checked={formData?.is_roommate === "0"}
                                    onChange={handleInputChange}
                                    required
                                />
                                <p className='radioLabel mb-0'>{t("accomodation.roomArrange")}</p>
                            </div>
                        </div>
                        {errors.is_roommate && <span className="error">{errors.is_roommate}</span>}
                        {formData?.is_roommate && formData?.is_roommate === "1" &&
                            <>
                                <div className="form-item">
                                    <label for="roommate_id" className="form-label">{t("accomodation.Roommate_ID")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="roommate_id"
                                        placeholder=""
                                        value={formData.roommate_id || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                {errors.roommate_id && <span className="error">{errors.roommate_id}</span>}
                                <div className="form-item">
                                    <label for="roommate_name" className="form-label">{t("accomodation.Roommate_Name")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="roommate_name"
                                        placeholder=""
                                        value={formData.roommate_name || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                {errors.roommate_name && <span className="error">{errors.roommate_name}</span>}
                                <div className="form-item">
                                    <label for="roommate_relationship" className="form-label">{t("accomodation.Roommate_Relationship")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="roommate_relationship"
                                        placeholder=""
                                        value={formData.roommate_relationship || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                {errors.roommate_relationship && <span className="error">{errors.roommate_relationship}</span>}
                            </>
                        }
                    </>
                }
            />
            <CustomModal
                hideModal={toggleChangeStayDateModal}
                open={isChangeStayDateModalOpen}
                performAction={closeChangeStayDateModal}
                title={t("accomodation.UpdateInformation")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("accomodation.Confirmation")}
                    </p>
                }
            />
            {formData === "" || originalData === "" ?
                <div className='info-container'>
                    <h3>{t("accomodation.title")}</h3>
                    <p>{t("accomodation.title2")}</p>
                    {isLoading ?
                        <>
                            <AiOutlineLoading className='spin' />
                            <p>{t("accomodation.Loading_form")}</p>
                        </>
                        :
                        <>
                            <p style={{ "color": "#ff0000" }}><Trans key="accomodation" html="br:<br/>">
                                <br />{t("accomodation.EmptyForm")}
                            </Trans></p>
                            <div className='action-buttons'>
                                <Link to={`${base_url}/retreat-accommodation`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("accomodation.SubmitForm")}</Button>
                                </Link>

                            </div>
                        </>
                    }
                </div>
                :
                <>
                    <div className='info-container'>
                        <h3>{t("accomodation.title")}</h3>
                        <p>{t("accomodation.title2")}</p>
                        <Button
                            buttonStyle='btn--primary'
                            buttonSize='btn--small'
                            onClick={handleDownloadConfirmation}
                        >
                            <FaFilePdf className="me-2" />
                            {t("accomodation.DownloadConfirmation")}
                        </Button>
                    </div>
                    {!isEditing ?
                        <>
                            <div className='form-wrapper mt-3'>
                                <h3 className='mt-2'></h3>
                                <p><strong>
                                    {t("accomodation.informationSTAY")}<br />
                                    {originalData.room_type_assigned !== null && originalData.room_type_assigned !== "" &&
                                        <span className='error'>{t("accomodation.ROOMassign")}</span>
                                    }
                                </strong>
                                </p>
                                <table className="table table-light">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t("accomodation.TitleSTAY")}</th>
                                            <th scope="col">{t("accomodation.ItemSelected")}</th>
                                            <th className='action-table-row' scope="col">{t("accomodation.Action")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>{t("accomodation.RoomDecide")}</th>
                                            <td>{invoiceItemCopy.find(i => i.key === originalData?.room_type).title}</td>
                                            <td className='action-table-row'>
                                                <button onClick={""} className="action-button"><CgArrowsExchangeAlt className='fs-3' /></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("accomodation.RoomGiven")}</th>
                                            <td><span className='error'>
                                                {
                                                    originalData.room_type_assigned !== null &&
                                                        originalData.room_type_assigned !== "" ?
                                                        invoiceItemCopy.find(i => i.key === originalData?.room_type_assigned).title
                                                        :
                                                        t("interview.DecideYET")
                                                }
                                            </span></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <th>
                                                {t("accomodation.AddON")}
                                                <IoInformationCircle data-tooltip-id="bed_tooltip" />
                                            </th>
                                            <td>{originalData.is_addon_bed === "1" ? t("general.yes") : t("general.no")}</td>
                                            <td className='action-table-row'>
                                                <button onClick={toggleAddOnBedModal} className="action-button"><FaBed className='fs-4' /></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("accomodation.StayDuration")}</th>
                                            <td>{convertToUTCDateInputFormat(originalData.check_in_date)} to {convertToUTCDateInputFormat(originalData.check_out_date)}</td>
                                            <td className='action-table-row'>
                                                <button onClick={toggleChangeStayDateModal} className="action-button"><FaEdit className='fs-4' /></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("accomodation.ROOMMATEtitle")}</th>
                                            <td>
                                                {originalData.is_roommate === "1" ?
                                                    <>{originalData.roommate_id}-{originalData.roommate_name}（{originalData.roommate_relationship}）</>
                                                    : t("interview.DecideYET")}
                                            </td>
                                            <td className='action-table-row'>
                                                <button onClick={toggleChangeRoommateModal} className="action-button"><FaEdit className='fs-4' /></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="table table-info table-striped mt-5">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col">{t("Constant.TwinRoom")}<br />{t("Constant.twinBedSize")}</th>
                                            <th scope="col">{t("Constant.KingRoom")}<br />{t("Constant.kingBedSize")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className='th-row' scope="row"><Trans key="accomodation" html="br:<br/>">
                                                {t("accomodation.contentTitle")}
                                            </Trans></th>
                                            <td>{t("accomodation.RM1950")}</td>
                                            <td>{t("accomodation.RM1950")}</td>
                                        </tr>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.contentTitle2")}</th>
                                            <td>{t("accomodation.RM200")}</td>
                                            <td>{t("accomodation.RM200")}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="image-radio-container">
                                    <div className="room-radio-option">
                                        <span>
                                            <img
                                                src={`${base_url}/images/twinroom.JPG`}
                                                alt="Twin Room"
                                            />
                                        </span>
                                        <p>{t("Constant.TwinRoom")} (MYR 1950)</p>
                                    </div>
                                    <div className="room-radio-option">
                                        <span>
                                            <img
                                                src={`${base_url}/images/kingroom.JPG`}
                                                alt="King Room"
                                            />
                                        </span>
                                        <p>{t("Constant.KingRoom")} (MYR 1950)</p>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="form-wrapper">
                                <>
                                    <div className='action-buttons d-flex justify-content-center'>
                                        <Button
                                            buttonStyle='btn--primary'
                                            buttonSize='btn--small'
                                            onClick={handleCancel}
                                        >{t("general.BTNcancel")}</Button>
                                    </div>
                                    <form>
                                        <div className="form-item">
                                            <label for="checkin-period" className="form-label">{t("accomodation.Previous_Period")}</label>
                                            <input type="text" className="form-control" id="ori_stay_days" readOnly
                                                value={`${format(originalData.check_in_date, 'dd-MM-yyyy')}  to  ${format(originalData.check_out_date, 'dd-MM-yyyy')}`}
                                            />
                                        </div>
                                        <div className='form-item'>
                                            <label for="check_in_date" className="form-label">{t("accomodation.checkInDate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input
                                                type='date'
                                                id="check_in_date"
                                                onChange={handleInputChange}
                                                value={formData.check_in_date || ""}
                                                min="2025-03-21"
                                                max="2025-03-26"
                                                required
                                            />
                                        </div>
                                        {errors.check_in_date && <p className='m-0'><span className="error">{errors.check_in_date}</span></p>}
                                        <div className='form-item'>
                                            <label for="check_out_date" className="form-label">{t("accomodation.checkOutDate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input
                                                type='date'
                                                id="check_out_date"
                                                onChange={handleInputChange}
                                                value={formData.check_out_date || ""}
                                                min="2025-04-01"
                                                max="2025-04-03"
                                                required
                                            />
                                        </div>
                                        {errors.check_out_date && <p className='m-0'><span className="error">{errors.check_out_date}</span></p>}


                                        {/* <div className="form-item">
                                            <label for="checkin-period" className="form-label"><span style={{ "color": "#ff0000" }}>{t("accomodation.changeroomDATE")}</span></label>
                                            <input ref={buttonRef} type="text" className="form-control" onClick={() => setOpenDatePicker(!openDatePicker)} id="checkin_period" readOnly
                                                value={`${format(selectionRange.startDate, 'dd-MM-yyyy')}  to  ${format(selectionRange.endDate, 'dd-MM-yyyy')}`}
                                            />
                                        </div>
                                        {errors.check_in_date && <p className='m-0'><span className="error">{errors.check_in_date}</span></p>}
                                        {errors.check_out_date && <p className='m-0'><span className="error">{errors.check_out_date}</span></p>}
                                        {openDatePicker &&
                                            <div ref={calendarRef} style={{ "maxWidth": "350px" }}>
                                                <DateRange
                                                    className=''
                                                    ranges={[selectionRange]}
                                                    onChange={handleSelect}
                                                    minDate={new Date('2025-03-22')}
                                                    maxDate={new Date('2025-04-03')}
                                                    months={2}
                                                    direction="vertical"
                                                    preventSnapRefocus={true}
                                                    showSelectionPreview={true}
                                                    showMonthAndYearPickers={false}
                                                    showDateDisplay={false}
                                                    showMonthArrow={false}
                                                />
                                            </div>
                                        } */}


                                        <h4 className='mt-4'>{t("accomodation.CheckoutAmount")}</h4>
                                        <table className="table table-light table-info">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{t("accomodation.AmtTitle")}</th>
                                                    <th scope="col">{t("accomodation.AmtItem")}</th>
                                                    <th scope="col">{t("accomodation.AMT")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.STAYb4")}</th>
                                                    <td>{totalStayDaysBefore} {t("accomodation.days")}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.Staynow")}</th>
                                                    <td>{totalStayDaysNow} {t("accomodation.days")}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.DayAmount")}</th>
                                                    <td>{differentStayDays} {t("accomodation.days")}</td>
                                                    <td>MYR {checkoutItem.amountDifference}</td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.TourismTax")}</th>
                                                    <td>{passportRegion === "Malaysia" ? t("accomodation.msia") : t("accomodation.non_msia")}</td>
                                                    <td>MYR {checkoutItem.tourismTax}</td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.TransactionFees")}</th>
                                                    <td>{formData.payment_mode === "creditcard" ? t("accomodation.CreditCard") : t("accomodation.OfflineTransfer")}</td>
                                                    <td>MYR {transactionFee}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td className='th-row'><strong>{t("accomodation.TotalRM")} ({t("accomodation.myr")})</strong></td>
                                                    <td><strong>{totalAmount.totalAmount}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td className='th-row'><strong>{t("accomodation.TotalCurrency")} ({currencySelected.key || "MYR"})</strong></td>
                                                    <td><strong>{totalAmount.totalAmountInCurrencySelected}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {totalAmount.totalAmount > 0 &&
                                            <>
                                                <div className="form-item">
                                                    <label>{t("accomodation.PaymentMethod")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <div className='radio'>
                                                        <input className="form-check-input p-2" type="radio" name="payment_mode" id="creditcard" onChange={handleInputChange} required />
                                                        <p className='radioLabel mb-0'>{t("accomodation.Method1")}</p>
                                                    </div>
                                                    <div className='radio'>
                                                        <input className="form-check-input p-2" type="radio" name="payment_mode" id="offline" onChange={handleInputChange} required />
                                                        <p className='radioLabel mb-0'>{t("accomodation.Method2")}<span style={{ color: "#ff0000" }}>&nbsp;{t("accomodation.Method2Remind")}</span></p>
                                                    </div>
                                                </div>
                                                {errors.payment_mode && <span className="error">{errors.payment_mode}</span>}
                                                {paymentMethod === "offline" &&
                                                    <>
                                                        <div className="form-item">
                                                            <label>{t("accomodation.cURRENCY")}
                                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                                            <select className="form-select" onChange={handleCurrencyChange} id="offline_payment_currency" required>
                                                                <option value="">{t("accomodation.ChooseCurrency")}</option>
                                                                {currencyCopy.map((item, index) => (
                                                                    <option key={index} value={item.key}>{item.currency}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        {errors.offline_payment_currency && <span className="error">{errors.offline_payment_currency}</span>}
                                                        {
                                                            currencySelected !== "" &&
                                                            bankInfoCopy
                                                                .filter((i) => i.key === currencySelected.key)
                                                                .map((i, index) => (
                                                                    <div className='section-title mb-2 mt-4' key={index}>
                                                                        <p>
                                                                            <strong>{i.title}</strong>
                                                                            <br />
                                                                            {i.subtitle}
                                                                            <br />
                                                                            {i.bank && <>{t("accomodation.bank")} {i.bank}<br /></>}
                                                                            {i.image && <><img src={i.image} style={{ "width": "250px" }} alt="" /><br /></>}
                                                                            {i.account && <>{t("accomodation.acc_Num")} {i.account} <br /></>}
                                                                            {i.name && <>{t("accomodation.acc_Name")} {i.name}<br /></>}
                                                                            {i.shiftcode && `SWIFT Code: ${i.shiftcode}`}
                                                                        </p>
                                                                    </div>
                                                                ))
                                                        }
                                                        <div className="form-item">
                                                            <label for="transaction-prove" className="form-label">
                                                                {t("accomodation.Upload_Res")}
                                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                onChange={handleFileChange}
                                                                id="offline_payment_prove"
                                                            />
                                                        </div>
                                                        <div className="form-info mt-2">
                                                            <p className='mb-0'>{t("general.smallerFile")}</p>
                                                        </div>
                                                        {fileError && <div className="error mt-2">{fileError}</div>}
                                                        {errors.offline_payment_prove && <span className="error">{errors.offline_payment_prove}</span>}
                                                    </>
                                                }
                                                {paymentMethod === "creditcard" &&
                                                    <Elements
                                                        stripe={stripePromise}
                                                        options={{
                                                            mode: "payment",
                                                            amount: convertToSubcurrency(((Number(netTotalAmount) + Number(checkoutItem.tourismTax) + 1) / 0.96).toFixed(2)),
                                                            currency: "myr",
                                                        }}
                                                    >
                                                        <Checkout
                                                            amount={((Number(netTotalAmount) + Number(checkoutItem.tourismTax) + 1) / 0.96).toFixed(2)}
                                                            formData={setNullFormToEmpty(formData)}
                                                            validateAllFields={validateAllFields}
                                                            checkoutItem={checkoutItem}
                                                            transactionFee={Number(((0.04 * (Number(netTotalAmount) + Number(checkoutItem.tourismTax)) + 1) / 0.96))}
                                                            netTotalAmount={Number(netTotalAmount)}
                                                            generateValidationFields={generateValidationFields}
                                                        />
                                                    </Elements>
                                                }
                                            </>
                                        }
                                        {checkoutItem.isRefund === "1" &&
                                            <span className='error'>{t("accomodation.confirmREFUND")}</span>
                                        }
                                        <div className='button-container mt-3'>
                                            <Button buttonStyle="btn--primary" onClick={handleSubmit} hidden={paymentMethod === "creditcard"} type="button">
                                                {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                                            </Button>
                                        </div>

                                    </form>
                                </>
                            </div>
                        </>
                    }
                </>
            }
            <Tooltip
                id="bed_tooltip"
                place="top"
                content={t("accomodation.ApplicableContent")}
            />
        </>

    )
}

export default ViewAccomodation